import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {LocalDeviceDetectorService} from 'dmmp-services'

@Component({
  selector: 'dmmp-form-file-list',
  templateUrl: './file-list.component.html',
})
export class FileListComponent {
  @Input() arrayFiles: any
  @Input() accept: string
  @Input() sizeFilePermitted: number
  @Output() deleteFileOut = new EventEmitter()
  labelButton = 'Eliminar'
  textFormatInvalid = 'Formato y/o peso no admitido, este archivo no será cargado'

  constructor(public localDeviceDetectorService: LocalDeviceDetectorService) {
  }

  deleteFile(position) {
    this.arrayFiles.splice(position, 1)
    this.deleteFileOut.emit(this.arrayFiles)
  }
}
